$( document ).ready(function() {
  $( ".productgrid--sidebar-title--small" ).click(function() {
    $(this).parent(".col-box-filter").toggleClass("active");
    $(this).siblings(".productgrid--sidebar-item.filter-group").toggle();
  });

  $(function() {
    setTimeout(function() {
		$('.productgrid--item').each(function(){
        	$(this).find('.SPCMP_chk_lbl').appendTo($(this).find('.add-to-compare'));
       	});
    }, 7000);
  });
  
});



